React = require 'react'
t = require('views/internal/recup-with-helpers')('canonical_comment')
Controller = require 'controller'
TFM = require 'lib/markdown/tfm'
{ Avatar } = require '@atlassian/trello-canonical-components/canonical-card'
{
  ButtonLink
  Icon
  ReplyActions
  ReplyColumnAvatar
  ReplyColumnContent
  ReplyColumns
  ReplyContainer
  ReplyLink
  ReplySentText
  ReplyTextarea
} = require '@atlassian/trello-canonical-components/canonical-comment'

forwardIcon = require 'images/canonical-comment/forward-icon.svg'

module.exports = class CanonicalComment extends React.Component
  displayName: 'CanonicalCommentInlineReply'

  constructor: (props) ->
    super(props)

    @state = { sentAnimationComplete: false }

    @sentAnimationTimeout = null

  componentWillUnmount: ->
    if @sentAnimationTimeout?
      clearTimeout(@sentAnimationTimeout)

  componentWillReceiveProps: (nextProps) ->
    if (nextProps.hasReplied != @props.hasReplied)
      if @sentAnimationTimeout?
        clearTimeout(@sentAnimationTimeout)

      @sentAnimationTimeout = setTimeout(=>
        @setState(sentAnimationComplete: nextProps.hasReplied)
      , 2000)

  render: t.renderable ->
    {
      memberCreator
      onSaveClick
      onCancelClick
      onChangeReplyMessage
      replyAction
      replyMessage
      isReplying
      hasReplied
    } = @props

    { sentAnimationComplete } = @state

    avatarHash = memberCreator?.get('avatarHash')

    t.tag ReplyContainer, =>
      if isReplying
        t.tag ReplyColumns, key: 'reply-textarea', =>
          t.tag ReplyColumnAvatar, =>
            t.tag Avatar, {
              lightBackground: true
              key: memberCreator?.id
              deactivated: memberCreator?.get('isDeactivated')
              img: avatarHash and [window.avatarDomain, avatarHash, '30.png'].join('/')
              img2x: avatarHash and [window.avatarDomain, avatarHash, '50.png'].join('/')
              initials: memberCreator?.get('initials')
            }
          t.tag ReplyColumnContent, =>
            t.tag ReplyTextarea, {
              value: replyMessage
              onChange: onChangeReplyMessage
              className: 'canonical-reply-text-area'
            }
            t.tag ReplyActions, =>
              t.tag ButtonLink, {
                onClick: onSaveClick
                className: 'canonical-reply-button-link'
              }, =>
                t.format 'save'
              t.tag ButtonLink, {
                onClick: onCancelClick
                className: 'canonical-reply-button-link'
              }, =>
                t.format 'cancel'
      else if hasReplied
        if sentAnimationComplete && replyAction
          t.tag ReplyLink, {
            key: 'reply-link'
            href: if replyAction.id then Controller.getActionUrl(replyAction) else null
           }, =>
            t.tag ReplyColumns, centered: true, =>
              t.tag ReplyColumnAvatar, {
                className: 'canonical-reply-sent-avatar'
              }, =>
                t.tag Avatar, {
                  lightBackground: true
                  size: 24
                  key: memberCreator?.id
                  deactivated: memberCreator?.get('isDeactivated')
                  img: avatarHash and [window.avatarDomain, avatarHash, '30.png'].join('/')
                  img2x: avatarHash and [window.avatarDomain, avatarHash, '50.png'].join('/')
                  initials: memberCreator?.get('initials')
                }
              t.tag ReplyColumnContent, =>
                t.tag ReplySentText, =>
                  t.text TFM.comments.text(replyAction.get('data').text).output
              t.tag Icon, {
                icon: forwardIcon
                iconName: 'forwardIcon'
                height: 16
                width: 16
                className: 'canonical-reply-link-icon'
              }
        else
          t.tag ReplyColumns, {
            key: 'reply-sent'
            centered: true
          }, =>
            t.tag ReplyColumnContent, =>
              t.tag ReplySentText, { centered: true }, =>
                t.format 'reply-sent'



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-comment/canonical-comment-inline-reply.coffee